function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.8852 12.0142L20.5002 7.39918V16.6292L15.8852 12.0142ZM4.75024 17.5002L9.17524 13.0752L11.2932 15.1922C11.6832 15.5832 12.3162 15.5832 12.7072 15.1922L14.8242 13.0752L19.2502 17.5002H4.75024ZM3.50024 7.39918L8.11424 12.0142L3.50024 16.6292V7.39918ZM7.72024 6.50018H16.2792H18.4012H19.2782L14.8242 10.9532L13.7642 12.0142L12.0002 13.7782L10.2362 12.0142L9.17524 10.9532L4.72124 6.50018H5.59924H7.72024ZM21.0002 5.00018H20.8992H19.9012H18.7782H17.7792H6.22024H5.22124H4.09924H3.10024H3.00024C2.44724 5.00018 2.00024 5.44818 2.00024 6.00018V18.0002C2.00024 18.0382 2.01724 18.0702 2.02124 18.1072C2.07724 18.6062 2.48624 19.0002 3.00024 19.0002H3.25024H20.7502H21.0002C21.5142 19.0002 21.9232 18.6062 21.9782 18.1072C21.9822 18.0702 22.0002 18.0382 22.0002 18.0002V6.00018C22.0002 5.44818 21.5522 5.00018 21.0002 5.00018Z",
  fill: "white"
});

function SvgIconEnvelope(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnvelope);
export default __webpack_public_path__ + "static/media/iconEnvelope.25294ade.svg";
export { ForwardRef as ReactComponent };